import { apiSlice } from "../../../shared/slices/apiSlice";
import { User } from "../../../shared/utils/interfaces/AuthInterface";
import { IUpdateUserPassword } from "../../../shared/utils/interfaces/apisInterfaces";

export const settingApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        updateUserData: builder.mutation({
            query: (userData: User) => ({
                url: "/users",
                method: "PATCH",
                body: userData,
            }),
        }),
        updateUserPassword: builder.mutation({
            query: (passwordData: IUpdateUserPassword) => ({
                url: "/auth/updatePassword",
                method: "POST",
                body: passwordData,
            }),
        }),
        getPlans: builder.query({
            query: () => '/users/plans',
        }),
        unSubscribePlan: builder.mutation({
            query: () => ({
                url: "/users/unsubscribe",
                method: "PATCH"
            }),
        }),
        getUserCurrentPlan: builder.query({
            query: () => 'users/company/plan',
        }),
        logContactSalesPlan: builder.mutation({
            query: (body: { planId: number }) => ({
                url: "/logs/contactSales",
                method: "POST",
                body
            }),
        }),
    })
})
export const { useUpdateUserDataMutation, useUpdateUserPasswordMutation, useGetPlansQuery, useUnSubscribePlanMutation, useLazyGetUserCurrentPlanQuery, useLogContactSalesPlanMutation } = settingApiSlice
